import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgForm, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import * as bootstrap from 'bootstrap';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';
import { getParamsType } from '../model/getParamsType';
import { SharedService } from './shared.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
    standalone: false
})

export class ServicesComponent implements OnInit, AfterViewInit {
  loading: boolean = false;
  services = [
              {name: 'COVID-19',islected:false} ,             
              {name: 'Flu',   islected:false} ,
              {name: 'Pneumonia',islected:false},
              {name: 'Shingles',   islected:false} ,
              {name: 'Tetanus',islected:false},
              {name: 'Hepatitis B',   islected:false} 
             ];

 screeningArray = [{name: 'A1C',islected:false},
             {name: 'Blood Glucose',islected:false} ,
             {name: 'Cholesterol/Lipid Panel',islected:false}
            ];   

 additionalServicesArray = [{name: 'Covid-19 Testing',islected:false},
            {name: 'Travel Health',islected:false}
           ];   
            
  learnMoreServices:any= environment.base_url=="https://rxie-qa.albertsons.com/"?"https://b2b-qa2-origin.albertsonscompanies.com/vaccine-clinics.html": "https://b2b.albertsonscompanies.com/vaccine-clinics.html ";//"https://b2b.albertsonscompanies.com/vaccine-clinics.html";          
  serviceError: Boolean = true;
  screeningArrayError: Boolean =true;
  additionalServicesArrayError:Boolean=true;
  otherServiceTypeError : Boolean = true;

  firstLoad: Boolean = false;
  selectedScreeningArrayValues: Array<string> = [];
  selectedServiceValues: Array<string> = [];
  selectedadditionalServicesArrayValues: Array<string> = [];
  leadId: any;
  leadType: any;
  nestedForm: FormGroup = new FormGroup({});
  aci_clinictype : any;
  clinicId: any;
  clinicSubscriber: any;
  clinicData: any;
  isoniste : boolean = false;
  voucher : boolean = false;
  aci_otherservicetype : any;
  clinicForm: FormGroup = this._fb.group({
    aci_immunizationtype: this._fb.group({
      covid19: [''],
      flu: [''],
      shingrix: [''],
      tdap: [''],
      pneumonia: [''],
    }),
    aci_clinicservicetype: this._fb.group({
      covid19testing: [''],
      a1ctesting: [''],
      cholestrol: [''],
      bloodglucose : [''],
    })
  });
  action : any
  showPreviousbtn:boolean=true;
  nextBtnText:string="Next"
  previuosButtonTabIndex: any = -1;
  AriaTextSubmitBtn:any ;
  constructor(private router: Router, protected $gaService: GoogleAnalyticsService,private _fb: FormBuilder,private route: ActivatedRoute,public sharedService: SharedService) { 

  }
  
  ngAfterViewInit(): void {
  

    document.querySelectorAll('[data-bs-toggle="tooltip"]');
   
  
  }
  

  ngOnInit(): void {
    
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.get('id');
      this.clinicId = params.get('gid');
      this.leadType = params.get('leadType');
      this.action=params.get('action');
      if(this.action=='RE'||this.action=='CE'){
        this.showPreviousbtn=false;
        this.nextBtnText="Back";
      }
      if (this.leadId && (this.leadType === 'update' || !this.leadType))
      if(this.action != 'multipleclinic')
          {
            if (this.clinicId) this.getClinicDetails(this.clinicId);
          }
    });

    var device = this.$gaService.mobileOrLaptopdevice();
    if(device=="Mobile"){
      this.AriaTextSubmitBtn=this.nextBtnText=="Next" ? "Next button double tap to activate the ": "Back button double tap to activate the "
    }
    else{
      this.AriaTextSubmitBtn =this.nextBtnText;
    }
  }
  isChecked:boolean=false;
  onChange(items:any){
console.log(items);

  }

  onServicesFormSubmit(form: NgForm) {
    this.loading=true;
   let submitObj = JSON.parse(JSON.stringify(form.value));
if(this.voucher){
  console.log(this.voucher);
  
}
if (this.isoniste){
  console.log(this.isoniste);
}

    if (submitObj.aci_clinictype == 'On-site at your location') {
      submitObj.aci_clinictype = '805170000';
    } else {
      submitObj.aci_clinictype = '805170002';
    }

    if(this.voucher && this.isoniste){
      submitObj.aci_clinictype = '805170002,805170000';
    }
    else if (this.voucher){
      submitObj.aci_clinictype = '805170002';
    }
    else if(this.isoniste) {
      submitObj.aci_clinictype = '805170000';
    }

    
    submitObj['aci_LeadId@odata.bind'] = `/leads(${this.leadId})`;
    let immunizeValueObj: string[] = [];
    

    this.services.forEach((d) => {
      if (d.name === 'COVID-19' && d.islected) {
          immunizeValueObj.push('805170000');
      }
      if (d.name === 'Flu' && d.islected) {
          immunizeValueObj.push('805170001');
      }
      if (d.name === 'Shingles' && d.islected) {
          immunizeValueObj.push('805170003');
      }
      if (d.name === 'Tetanus' && d.islected) {
          immunizeValueObj.push('805170004');
      }
      if (d.name === 'Pneumonia' && d.islected) {
          immunizeValueObj.push('805170005');
      }
      if (d.name === 'Hepatitis B' && d.islected) {
          immunizeValueObj.push('805170006');
      }
  });
  

    if (immunizeValueObj.length > 0) {
      submitObj['aci_immunizationtype'] = immunizeValueObj.join(',');
    }
   

    let serviceValueObj: string[] = [];
    

    this.screeningArray.forEach((d) => {
      if (d.name === 'A1C' && d.islected) {
          serviceValueObj.push('805170001');
      }
      if (d.name === 'Cholesterol/Lipid Panel' && d.islected) {
          serviceValueObj.push('805170002');
      }
      if (d.name === 'Blood Glucose' && d.islected) {
          serviceValueObj.push('805170003');
      }
  });
  



    this.additionalServicesArray.forEach((d) => {
      if (d.name === 'Covid-19 Testing' && d.islected) {
          serviceValueObj.push('805170000');
      }
      if (d.name === 'Travel Health' && d.islected) {
          serviceValueObj.push('805170006');
      }
  });
  


    if(!this.otherServiceTypeError)
    {
      serviceValueObj.push('805170005');
      submitObj['aci_otherservicetype'] = this.aci_otherservicetype;
    }
    if (serviceValueObj.length > 0) {
      submitObj['aci_clinicservicetype'] = serviceValueObj.join(',');
    }
    console.log("aaaa",submitObj)
    if (this.clinicId)
    {
       submitObj['entityId'] = this.clinicId;
      this.sharedService
        .postRequest('groupclinic/updateClinic', submitObj)
        .subscribe(
          (response) => {
            this.loading = false;
           
           if(this.action=='RE'||this.action=='CE'){
            this.router.navigate(['/review-details', { id: this.leadId,gid:this.clinicId, action:this.action ,leadType: "Updateclinic"}])
          }
          else if(this.action == 'singleclinic')
          {
            this.router.navigate(['/clinic-details', { id:this.leadId,clinicId: this.clinicId, leadType: "singleclinic" }])
        }
        else if (this.action == 'noclinic')
        {
          this.router.navigate(['/clinic-details', { id:this.leadId,clinicId: this.clinicId, leadType: "singleclinic" }])
        }
        else{
          this.router.navigate(['/clinic-details', { id:this.leadId,clinicId: this.clinicId, leadType: "Createclinic" }])
        }
          },
          (errorResponse) => {
            this.loading = false;
            console.log(errorResponse);
          }
        );

    }else{
      if(this.action == 'multipleclinic')
      {
       this.sharedService.postRequest('groupclinic/createClinic', submitObj).subscribe(res => {
         this.router.navigate(['/clinic-details', { id:this.leadId,clinicId: res.entityId, leadType: "multipleclinic" }])
       this.loading = false;
       }, errorResponse => {
        this.loading = false;
  });
      }
      else{
       this.sharedService.postRequest('groupclinic/createClinic', submitObj).subscribe(res => {
         this.router.navigate(['/clinic-details', { id:this.leadId,clinicId: res.entityId, leadType: "Createclinic" }])
       this.loading = false;
       }, errorResponse => {
        this.loading = false;
  });
      }
    }
  
   
  }

  
  getLeadDetails() {
    const url: string = `groupclinic/getClinicLead`;
    const getParams: getParamsType = {
      entityName: 'lead',
      entityId: this.leadId,
      columns:
        'companyname,emailaddress1,lastname,mobilephone,firstname',
    };
    this.sharedService.postRequest(url, getParams).subscribe(
      (response) => {
        let spouse;
        let children;
        if (response != null) {      

        }

      },
      (errorResponse) => {
        this.loading = false;
        console.log(errorResponse);
      }
    );
  }

  getClinicDetailsByLead()
  {
    const relativePath: string = `groupclinic/getClinicByLeadId`;
    const getParams: getParamsType = {
      entityName: 'aci_clinic',
      entityId: this.leadId,
      columns:
        'aci_clinictype,aci_immunizationtype,aci_clinicservicetype,_aci_leadid_value,aci_otherservicetype,aci_clinicid',
    };
    this.loading = true;
    this.clinicSubscriber = this.sharedService
      .postRequest(relativePath, getParams)
      .subscribe(
        (response) => {
          this.clinicData = response.value[0];

          console.log("this.clinicData",this.clinicData)
          if(this.clinicData != undefined)     
          {
            console.log("this.clinicData",this.clinicData)
            this.clinicId = response.value[0].aci_clinicid
            this.bindClinicData(response.value[0]);
          }  
          this.loading = false;
        },
        (errorResponse) => {
          this.loading = false;
          console.log(errorResponse);
        }
      );

  }
  

  getClinicDetails(clinicId: any) {
    const relativePath: string = `groupclinic/getClinic`;
    const getParams: getParamsType = {
      entityName: 'aci_clinic',
      entityId: clinicId,
      columns:
        'aci_clinictype,aci_immunizationtype,aci_clinicservicetype,_aci_leadid_value,aci_otherservicetype',
    };

    this.loading = true;
    this.clinicSubscriber = this.sharedService
      .postRequest(relativePath, getParams)
      .subscribe(
        (response) => {
          this.clinicData = response;
          if (this.clinicData) {
            this.bindClinicData(response);
          }
          this.loading = false;
        },
        (errorResponse) => {
          this.clinicId = '';
          this.loading = false;
          console.log(errorResponse);
        }
      );
  }
  addServicesControls() {
    const arr = this.services.map(item => {
      return this._fb.control(item.name);
    });

    return this._fb.array(arr);
  }

  get servicesArray() {
    return <FormArray>this.nestedForm.get('seviceControls');
  }

  bindClinicData(response:any){
  
    if (response.aci_clinictype) {
      var clinistyes=response.aci_clinictype;
      var listofclinictypes = clinistyes.split(',');
      for (var i = 0; i < listofclinictypes.length; i++) {
        var stringPart = listofclinictypes[i];
       if(stringPart=="805170000"){
        this.isoniste = true;
       }
       if(stringPart=="805170002"){
        this.voucher = true;
       }
    } 

  
      
    }

    this.leadId = response._aci_leadid_value;
    let covid19;
    let flu;
    let shingrix;
    let tdap;
    let pneumonia;
    
   

    if (response.aci_immunizationtype) {
      this.serviceError=false;
      let immunizationArray = response.aci_immunizationtype.split(',');
      immunizationArray.map((row: any) => {
        if (row == '805170000') {
          covid19 = true;
          this.services[0].islected = true;
          
        }
        if (row == '805170001') {
          flu = true;
          this.services[1].islected = true;
        }
        if (row == '805170003') {
          shingrix = true;
          this.services[3].islected = true;
        }
        if (row == '805170004') {
          tdap = true;
          this.services[4].islected = true;
        }
        if (row == '805170005') {
          pneumonia = true;
          this.services[2].islected = true;
        }
        if (row == '805170006') {
          pneumonia = true;
          this.services[5].islected = true;
        }
      });
    }
    let covid19testing;
    let a1ctesting;
    let cholestrol;
    let bloodglucose;
  
    
    if (response.aci_clinicservicetype) {
      this.additionalServicesArrayError=false;
      this.screeningArrayError=false;
      
      let serviceArray = response.aci_clinicservicetype.split(',');
      serviceArray.map((row: any) => {
        if (row == '805170000') {
          covid19testing = true;
          this.additionalServicesArray[0].islected = true;
        }
        if (row == '805170006') {
          covid19testing = true;
          this.additionalServicesArray[1].islected = true;
        }
        if (row == '805170005') {
          this.otherServiceTypeError = false;
          covid19testing = true;
          this.aci_otherservicetype = response.aci_otherservicetype;
        }
        if (row == '805170001') {
          a1ctesting = true;
          this.screeningArray[0].islected = true;
        }
        if (row == '805170002') {
          cholestrol = true;
          this.screeningArray[2].islected = true;
        }
        if (row == '805170003') {
          bloodglucose = true;
          this.screeningArray[1].islected = true;
        }
        
      });
    }

  }

  onsiteclick(): void{

    this.isoniste = !this.isoniste;
  }

  onvoucherclick(){
  
    this.voucher = !this.voucher
  }

  getSelectedServiceValue($event: any) {
    this.selectedServiceValues = [];
    const name = $event.target.value;
    const cehcked = $event.target.checked;
    if(cehcked)
    {
      this.firstLoad=true;
      
    }
    this.services = this.services.map((d)=>{
       if(d.name==name)
       {        
         d.islected=cehcked;
         return d
       }
       return d;
    });
    this.services.forEach((d)=>{
       if(d.islected)
       {
         this.selectedServiceValues.push(d.name);
       }
   });
      this.serviceError =  this.selectedServiceValues.length > 0 ? false : true;
      if (this.serviceError)
      {
        this.firstLoad=true;
      }
      console.log('finall',this.serviceError, this.firstLoad,this.screeningArrayError,this.additionalServicesArrayError)
}

getSelectedScreeningValue($event: any) {
  this.selectedScreeningArrayValues = [];
  const name = $event.target.value;
  const cehcked = $event.target.checked;
  if(cehcked)
  {
    this.firstLoad=true;
    
  }
  this.screeningArray = this.screeningArray.map((d)=>{
     if(d.name==name)
     {        
       d.islected=cehcked;
       return d
     }
     return d;
  });
  this.screeningArray.forEach((d)=>{
     if(d.islected)
     {
       this.selectedScreeningArrayValues.push(d.name);
     }
 });
    this.screeningArrayError =  this.selectedScreeningArrayValues.length > 0 ? false : true;
    if (this.screeningArrayError)
    {
      this.firstLoad=true;
    }
    console.log('finall',this.serviceError, this.firstLoad,this.screeningArrayError,this.additionalServicesArrayError)
}

getSelectedAdditionalServicesValue($event: any) {
  this.selectedadditionalServicesArrayValues = [];
  const name = $event.target.value;
  const cehcked = $event.target.checked;
  if(cehcked)
  {
    this.firstLoad=true;
    
  }
  this.additionalServicesArray = this.additionalServicesArray.map((d)=>{
     if(d.name==name)
     {        
       d.islected=cehcked;
       return d
     }
     return d;
  });
  this.additionalServicesArray.forEach((d)=>{
     if(d.islected)
     {
       this.selectedadditionalServicesArrayValues.push(d.name);
     }
 });
    this.additionalServicesArrayError =  this.selectedadditionalServicesArrayValues.length > 0 ? false : true;
    if (this.additionalServicesArrayError)
    {
      this.firstLoad=true;
    }
    console.log('finall',this.serviceError, this.firstLoad,this.screeningArrayError,this.additionalServicesArrayError)
}

onTextChange(value:any)
{
  this.aci_otherservicetype = value;
  if(this.aci_otherservicetype == '')
  {
    this.otherServiceTypeError = true;
  }
  else{
    this.otherServiceTypeError = false;
  }
  
}


  onPreviousClick() {
    this.sharedService.previousStep=true;
    if(this.action == 'singleclinic')
    {
      
      this.router.navigate(['/organisation', { id:this.leadId,gid: this.clinicId, action: "singleclinic" }])
    }
    else if(this.action == 'noclinic')
    {
      this.router.navigate(['/organisation', { id: this.leadId ,gid : this.clinicId , action : "noclinic" }])
    }
    else{
      this.router.navigate(['/organisation', { id: this.leadId }]);
    }
    
  }
  onNextButtonFocus(){
    this.previuosButtonTabIndex = 0;
  }
  onPreviousButtonFocus(){
    this.previuosButtonTabIndex = -1;
  }
}
